import * as React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./Card.module.scss";

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  elevation?: "none" | "sm" | "md" | "lg";
  size?: "default" | "small";
};

const DefaultCard = ({ className, ...props }: CardProps) => {
  const { elevation = "none", size = "default", ...otherProps } = props;
  return (
    <div
      data-slot="card"
      data-elevation={elevation}
      data-size={size}
      className={clsx(styles.card, className)}
      {...otherProps}
    />
  );
};
const Card = createPluggable<CardProps>("deci.card", DefaultCard);

const CardHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="card-header"
    className={clsx(styles.cardHeader, className)}
    {...props}
  />
);

const CardTitle = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="card-title"
    className={clsx(styles.cardTitle, className)}
    {...props}
  />
);

const CardDescription = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="card-description"
    className={clsx(styles.cardDescription, className)}
    {...props}
  />
);

const CardAction = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="card-action"
    className={clsx(styles.cardAction, className)}
    {...props}
  />
);

const CardContent = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="card-content"
    className={clsx(styles.cardContent, className)}
    {...props}
  />
);

const CardFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    data-slot="card-footer"
    className={clsx(styles.cardFooter, className)}
    {...props}
  />
);

export default Object.assign(Card, {
  Header: CardHeader,
  Footer: CardFooter,
  Title: CardTitle,
  Action: CardAction,
  Description: CardDescription,
  Content: CardContent,
});
